<script>
import mixinComponent from '../../../Mixins/mixinComponent'

export default {
  mixins: [mixinComponent],

  data() {
    return {
      isFilterArrowRotated: true,
    }
  },

  methods: {
    toggleCollapse() {
      this.isFilterArrowRotated = !this.isFilterArrowRotated
      this.$emit('toggle-collapse')
    },
  },
}
</script>
<template>
  <a
    @click="toggleCollapse"
    class="filter-button btn btn-block"
    :data-toast-title="$t('home.collaspeFilters')"
    e2e-button="toggleFilter"
  >
    <i
      class="fa fa-arrow-up"
      :class="{ filterButtonRotation: isFilterArrowRotated }"
      style="transition: transform 0.5s"
    ></i>
  </a>
</template>
